import type { Theme } from "@mui/material/styles/createTheme";
import Constants from "constants/index";

const navbar = (theme: Theme | any, ownerState: any): any => {
    const { palette, boxShadows, functions, transitions, breakpoints, borders } = theme;
    const { transparentNavbar, light, darkMode } = ownerState;

    const { dark, white, text, background } = palette;
    const { navbarBoxShadow } = boxShadows;
    const { rgba, pxToRem } = functions;
    const { borderRadius } = borders;

    return {
        boxShadow: transparentNavbar ? "none" : navbarBoxShadow,
        backdropFilter: transparentNavbar ? "none" : `saturate(200%) blur(${pxToRem(30)})`,
        backgroundColor:
            transparentNavbar
                ? "transparent !important"
                : rgba(darkMode ? background.default : white.main, 0.8),

        color: () => {
            let color;

            if (light) {
                color = white.main;
            } else if (transparentNavbar) {
                color = text.main;
            } else {
                color = dark.main;
            }

            return color;
        },
        top: pxToRem(12),
        display: "grid",
        alignItems: "center",
        borderRadius: borderRadius.xl,
        width: "auto",
        padding: "8px",
        minHeight: pxToRem(75),
        "& > *": {
            transition: transitions.create("all", {
                easing: transitions.easing.easeInOut,
                duration: transitions.duration.standard,
            }),
        },

        "& .MuiToolbar-root": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",

            [breakpoints.up("sm")]: {
                minHeight: "auto",
                padding: `${pxToRem(4)} ${pxToRem(16)}`,
            },
        },
    };
};

const navbarContainer = (them: Theme): any => ({
    padding: "0px !important",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
});

const navLink = (theme: Theme, ownerState: { isActive: boolean; isMobile: boolean }): any => {
    const {
        functions: { rgba },
        palette: { info, dark },
    } = theme;

    const { isActive, isMobile } = ownerState;

    const mobileStyles = () => ({
        px: "10px",
        py: "8px",
        borderRadius: 2,
        display: "flex",
        alignItems: "center",

        "&:hover": !isActive && {
            cursor: "pointer",
            color: info.main,
            backgroundColor: rgba(info.main, 0.1),
        },
        "&:focus": {
            color: info,
            backgroundColor: rgba(info.main, 0.3),
        },
        ...(isActive && {
            backgroundColor: rgba(info.main, 0.7),
        }),

        ".MuiTypography-root": {
            color: isActive ? Constants.Styles.WHITE_COLOR : dark.main,
            fontWeight: isActive ? 600 : 600,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textDecoration: "none",
            textOverflow: "ellipsis",
            letterSpacing: "0.03em",
        },
    });

    const desktopStyles = () => ({
        px: "10px",
        borderRadius: 2,
        display: "flex",
        alignItems: "center",

        "&:hover": !isActive && {
            color: info.main,
            cursor: "pointer",
            backgroundColor: rgba(info.main, 0.1),
        },
        "&:focus": {
            color: info,
            backgroundColor: rgba(info.main, 0.3),
        },

        ...(isActive && {
            backgroundColor: rgba(info.main, 0.7),
        }),

        ".MuiTypography-root": {
            color: isActive ? Constants.Styles.WHITE_COLOR : dark.main,
            fontWeight: isActive ? 600 : 500,
            whiteSpace: "nowrap",
            textDecoration: "none",
            textOverflow: "ellipsis",
            letterSpacing: "0.03em",
        },
    });

    return {
        ...(isMobile && mobileStyles()),
        ...(!isMobile && desktopStyles()),
    };
};

const drawerStyles = (theme: Theme) => {
    const {
        palette: { info },
    } = theme;
    return {
        width: "250px",
        padding: "1rem",
        "& a": {
            color: info.main,
        },
    };
};

export {
    navbar,
    navLink,
    drawerStyles,
    navbarContainer,
};
